import { createApiRequest } from '@/utils/services';

const buildPath = ({ ownerOrgId, relationshipId }) => {
  let path = `orgs/${ownerOrgId}/relationships`;

  if (relationshipId) {
    path = `${path}/${relationshipId}`;
  }

  return path;
};

export const fetchRelationship = ({ ownerOrgId, relationshipId }) =>
  createApiRequest({
    method: 'get',
    path: buildPath({ ownerOrgId, relationshipId }),
    throwErrors: true,
  });

export const createRelationship = ({ ownerOrgId, data }) =>
  createApiRequest({
    method: 'post',
    path: buildPath({ ownerOrgId }),
    throwErrors: true,
    data,
  });

export const updateRelationship = ({ ownerOrgId, relationshipId, data }) =>
  createApiRequest({
    method: 'put',
    path: buildPath({ ownerOrgId, relationshipId }),
    throwErrors: true,
    data,
  });

export const deleteRelationship = ({ ownerOrgId, relationshipId }) =>
  createApiRequest({
    method: 'delete',
    path: buildPath({ ownerOrgId, relationshipId }),
    throwErrors: true,
  });

const relationshipService = {
  fetchRelationship,
  createRelationship,
  updateRelationship,
  deleteRelationship,
};

export default relationshipService;
